/**
 * @documental
 * @export Placeholder
 * @name
 * NumberTextbox.Placeholder
 */
import { FC } from "react";
import Skeleton from "react-loading-skeleton";

import { BaseProps } from "../../BaseProps";
import { getBasePropsFromHtmlProps } from "../../utilities/getBasePropsFromHtmlProps";
import { getHtmlPropsFromBaseProps } from "../../utilities/getHtmlPropsFromBaseProps";
import { InputContainerPlaceholder } from "../shared/InputContainer/InputContainerPlaceholder";

import styles from "./styles.module.scss";

/**
 * The `Placeholder` component properties.
 */

export interface PlaceholderProps extends BaseProps {
  /**
   * Indicates whether the input has instructions. If not specified, defaults to `false`.
   */
  readonly hasInstructions?: boolean;
}

/**
 * A loading placeholder for the `NumberTextbox` component.
 */
export const Placeholder: FC<PlaceholderProps> = (props) => {
  const { hasInstructions = false } = props;

  const baseHtmlProps = getHtmlPropsFromBaseProps(props, {
    className: [styles.TextboxPlaceholder, "number-textbox", "placeholder"],
    testIdPrefix: "number-textbox",
  });

  return (
    <InputContainerPlaceholder {...getBasePropsFromHtmlProps(baseHtmlProps)} hasInstructions={hasInstructions}>
      <div className={styles.PlaceholderContent}>
        <Skeleton />
      </div>
    </InputContainerPlaceholder>
  );
};
